<template>
  <div class="classTicket-info mb-[32px]">
    <BaseElForm v-if="displayData" label-width="150px" label-position="left">
      <BaseElFormItem label="進場者姓名" testName="formData_name">
        <div v-if="inMemberProfile || displayData.identity === 'guest'">{{ get(displayData, 'name') }}</div>
        <div v-else class="underline cursor-pointer text-primary-100" @click="goToProfile(displayData)">{{ get(displayData, 'name') }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="進場者電話" testName="formData_phone">
        <div>{{ get(displayData, 'phone') }}</div>
      </BaseElFormItem>
      <div v-if="get(displayData, 'isAdmin')">
        <BaseElFormItem label="手動進場操作人" testName="formData_entryOperator_name">
          <div>{{ get(displayData, 'EntryOperator.name', '-') }}</div>
        </BaseElFormItem>
        <BaseElFormItem label="手動進場備註" testName="formData_entryNote">
          <div>{{ get(displayData, 'entryNote') }}</div>
        </BaseElFormItem>
      </div>
      <BaseElFormItem label="使用權益" testName="formData_entryEntitlementType">
        <div>{{ get(displayData, 'entryEntitlementType') === 'admin' ? '後台新增' : get(displayData, 'entitlementUsages') }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="進場門市" testName="formData_branchName">
        <div>{{ get(displayData, 'branchName') }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="進場時間" testName="formData_entryAt">
        <div>{{ get(displayData, 'entryAt') }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="出場時間" testName="formData_exitAt">
        <div>{{ get(displayData, 'exitAt') }}</div>
      </BaseElFormItem>
      <BaseElFormItem label="出場狀態" testName="formData_exitOrigin">
        <div class="flex items-center gap-[8px]">
          <Tag :type="selectStatus(displayData.status, displayData.exitOrigin, 'tagType')" style="display: inline-flex;">
            {{ selectStatus(displayData.status, displayData.exitOrigin, 'label') }}
          </Tag>
          <BaseElButton v-if="get(displayData, 'status') === 'entered'" type="text" class="btn edit" @click="manualExit">手動出場</BaseElButton>
        </div>
      </BaseElFormItem>
      <div v-if="get(displayData, 'exitOrigin') === 'admin'">
        <BaseElFormItem label="手動出場操作人" testName="formData_exitOperator_name">
          <div>{{ get(displayData, 'ExitOperator.name', '-') }}</div>
        </BaseElFormItem>
        <BaseElFormItem label="手動出場備註" testName="formData_exitNote">
          <div>{{ get(displayData, 'exitNote') }}</div>
        </BaseElFormItem>
      </div>
    </BaseElForm>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { get, map } from 'lodash'
import { useTable } from '@/use/table'
import { entryFilterStatusConfig, entitlementTypeUnitConfig } from '@/config/entryControl'
import { useRouter, useRoute } from 'vue-router/composables'

export default defineComponent({
  name: 'EntryInfoBlock',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const { dateFormat } = useTable()
    const router = useRouter()
    const route = useRoute()
    const inMemberProfile = computed(() => route.name === 'MemberProfile')
    const displayData = computed(() => {
      const data = props.data
      const entitlementUsages = map(get(data, 'entitlementUsages'), item => `「${item.entitlementName}」${item.amount} ${cardUnit(item.entitlementType)}`).join('、')
      return {
        ...data,
        name: get(data, 'Member.UserInfo.name') || get(data, 'guestInfo.name'),
        phone: get(data, 'Member.UserInfo.phone') || get(data, 'guestInfo.phone'),
        entitlementUsages,
        isAdmin: get(data, 'entryOrigin') === 'admin',
        entryNote: get(data, 'entryNote') || '-',
        branchName: get(data, 'Branch.name') || '-',
        entryAt: get(data, 'entryAt') ? dateFormat(get(data, 'entryAt')) : '-',
        exitAt: get(data, 'exitAt') ? dateFormat(get(data, 'exitAt')) : '-',
      }
    })
    const selectStatus = (status, origin, attr) => {
      if (origin === 'admin') {
        return get(entryFilterStatusConfig.manual, attr)
      }
      return get(entryFilterStatusConfig[status], attr)
    }
    const goToProfile = (row) => {
      // TODO: 次卡Tab or 點數卡Tab
      router.push(`/members/member-profile/${row.MemberId}/entryRecord`)
    }
    const cardUnit = (type, attr = 'label') => {
      return get(entitlementTypeUnitConfig[type], attr)
    }
    const manualExit = () => {
      emit('manualExit')
    }
    return {
      selectStatus,
      get,
      goToProfile,
      inMemberProfile,
      displayData,
      manualExit,
    }
  },
})
</script>

<style scoped lang="scss">
.btn {
  @apply underline text-normal font-normal;
}
.edit {
  @apply text-action;
}
</style>
